import {
    /** FETCH GETADDRESSES  */
    FETCH_GETADDRESSES_FULFILLED,
    FETCH_GETADDRESSES_REJECTED,
    FETCH_GETADDRESSES_PENDING,
    RESET_GETADDRESSES,
  } from "../../actions/payment/getAddresses";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETADDRESSES_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_GETADDRESSES_FULFILLED:
        return {
          ...state,
          getAddresses: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_GETADDRESSES_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_GETADDRESSES:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  